module.exports = __webpack_public_path__ + "img/YR25-0500-3-btn.d7b5e45c.png";